module.exports = __webpack_public_path__ + "assets/img/93a8-no.svg";